import type { RouteRecordRaw } from 'vue-router'

const SetupServicesPage = () => import('./pages/SetupServicesPage.vue')

const servicesSetupRoutes: RouteRecordRaw[] = [
  {
    name: 'services',
    path: 'services',
    component: SetupServicesPage,
    meta: { requiresAuth: true },
  },
]

export default servicesSetupRoutes
